import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import NonOpsContMain from "presentation/view/container/NonOps/NonOpsContMain";

CommonEntrypoint(<NonOpsContMain/>)